import { render, staticRenderFns } from "./BlogPostsProducts.vue?vue&type=template&id=74c019c6&"
import script from "./BlogPostsProducts.vue?vue&type=script&lang=js&"
export * from "./BlogPostsProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports